'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Col = function Col(_ref) {
  var children = _ref.children,
      span = _ref.span,
      total = _ref.total;

  return _react2.default.createElement(
    'div',
    { className: 'Col span-' + span + ' of-' + total },
    children
  );
};

Col.propTypes = {
  children: _propTypes2.default.node.isRequired,
  span: _propTypes2.default.number.isRequired,
  total: _propTypes2.default.number.isRequired
};

exports.default = Col;
Col.__docgenInfo = {
  'description': '',
  'methods': [],
  'displayName': 'Col',
  'props': {
    'children': {
      'type': {
        'name': 'node'
      },
      'required': true,
      'description': ''
    },
    'span': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': ''
    },
    'total': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': ''
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/components/Col.js
// module id = 270
// module chunks = 0